import { OpenAPI } from '@/client/core/OpenAPI'

// this function is needed instead the DocumentService because it can not handle Blobs correctly
export async function downloadResource({
  documentId,
  xTransactionId,
}: {
  documentId: string
  xTransactionId?: string | null
}): Promise<Blob> {
  const headers = new Headers()
  headers.append('Authorization', `Bearer ${OpenAPI.TOKEN}`)
  if (xTransactionId) {
    headers.append('x-transaction-id', xTransactionId)
  }

  const url = `${OpenAPI.BASE}/api/v1/software/documents/${encodeURIComponent(
    documentId
  )}/download`

  const res = await fetch(url, { method: 'GET', headers })
  if (!res.ok) throw new Error(`Download failed: ${res.statusText}`)
  return await res.blob()
}
